import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { readWorkbookPreview, renderWordPreview, WORD_PREVIEW_SHELL } from "./officePreviewAdapters";

export const OfficePreview = ({ blob, extension, filename, unpublished = false, sheetSelectorTarget = null }) => {
  const frame = useRef(null);
  const [state, setState] = useState({ loading: true });
  const [sheetIndex, setSheetIndex] = useState(0);
  useEffect(() => {
    let active = true;
    const isCurrent = () => active;
    const currentFrame = frame.current;
    let frameBody;
    setState({ loading: true });
    setSheetIndex(0);
    const fail = (error) => {
      if (active) setState({ error: error.message || "No se pudo preparar la vista previa." });
    };
    if (extension === "xlsx") {
      readWorkbookPreview(blob, isCurrent).then((workbook) => {
        if (active) setState({ workbook });
      }).catch(fail);
    } else {
      const prepare = async () => {
        if (!active || frameBody) return;
        const frameDocument = currentFrame.contentDocument;
        // Ignore the initial about:blank load; rendering requires the CSP shell.
        if (!frameDocument?.querySelector('meta[http-equiv="Content-Security-Policy"]')) return;
        frameBody = frameDocument.body;
        if (!frameBody) return;
        try {
          await renderWordPreview(blob, frameBody, isCurrent);
          if (active) setState({ ready: true });
        } catch (error) { fail(error); }
      };
      currentFrame.addEventListener("load", prepare);
      currentFrame.srcdoc = WORD_PREVIEW_SHELL;
      return () => {
        active = false;
        currentFrame.removeEventListener("load", prepare);
        frameBody?.replaceChildren();
      };
    }
    return () => { active = false; };
  }, [blob, extension]);

  const sheet = state.workbook?.sheets[sheetIndex];
  return <div className="forum-office-preview">
    {state.loading && <p role="status">Preparando vista previa…</p>}
    {state.error && <p role="alert">{state.error} {!unpublished && "Puedes descargar el archivo original."}</p>}
    {extension === "docx" && <iframe ref={frame} title={`Vista previa Word: ${filename}`}
      sandbox="allow-same-origin" referrerPolicy="no-referrer" hidden={!state.ready} />}
    {state.workbook && <>
      {(state.workbook.sheetsTruncated || sheet?.truncated) && <p role="status">Vista previa recortada. {!unpublished && "Descarga el original para ver todos los datos."}</p>}
      {!sheet?.rows.length ? <p>La hoja está vacía.</p> : <div className="forum-office-table forum-data-table" role="region" aria-label={`Vista previa Excel: ${sheet.name}`} tabIndex={0}>
        <table aria-label={`Vista previa Excel: ${sheet.name}`}><tbody>{sheet.rows.map((row, index) => <tr key={index}>
          {row.map((value, column) => <td key={column}>{value}</td>)}
        </tr>)}</tbody></table>
      </div>}
      {(() => {
        const selector = <label className="forum-sheet-selector">Hoja <select aria-label="Hoja de Excel" value={sheetIndex} onChange={(event) => setSheetIndex(Number(event.target.value))}>
          {state.workbook.sheets.map((item, index) => <option key={index} value={index}>{item.name}</option>)}
        </select></label>;
        return sheetSelectorTarget ? createPortal(selector, sheetSelectorTarget) : selector;
      })()}
    </>}
  </div>;
};
